// extracted by mini-css-extract-plugin
module.exports = {"modal":"_UwiRTlh","header":"_2DmeOfJ","body":"_21CP4sC","overlay":"_OxGlUNz","rootDisplayBlock":"_16_3DRs"};